import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import { IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { preferencias } from 'src/app/models/General/preferencias';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-preferencia-tren',
  templateUrl: './preferencia-tren.component.html',
  styleUrls: ['./preferencia-tren.component.scss']
})
export class PreferenciaTrenComponent extends preferencias implements OnInit {

  @ViewChild('Grupo_Preferencia_Tren_Observaciones') Grupo_Preferencia_Tren_Observaciones: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_Tren') grupos!: QueryList<GrupoPreferenciaComponent>;

  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  ETipoProducto = ETipoProducto;
  TipoPreferencia = ETipoPreferencia;

  @Input() preferencias: IPreferencia[];

  @Input() clienteFicha: IFichaCliente;
  @Input() listaOtros: string[];

  //Obtener la lista de las preferencias tren guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = []
    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });

    let textoObservacion = this.Grupo_Preferencia_Tren_Observaciones.obtenerPreferencias()
    let preferenciaTrenObservaciones: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('ObservacionTren'),
      Preferencias: null,
      InfoEspecifica: textoObservacion,
    }
    ListaPreferencias.push(preferenciaTrenObservaciones)

    return ListaPreferencias;

  }

  

  //Actualziar preferencias tren
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias
    let preferenciasTipoTren = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.Tren);
    let idsPreferencias = preferenciasTipoTren.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });

    let preferenciaTextoObservacionTren: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('ObservacionTren'))

    this.Grupo_Preferencia_Tren_Observaciones.actualizar(preferenciaTextoObservacionTren?.InfoEspecifica);
  }

  //Valdiar preferencias tren
  validarPreferencias() {
    let validacionPreferenciasTren = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    return validacionPreferenciasTren;
  }
}

